<template>
  <div id="app">
    <ChordCircle />
  </div>
</template>

<script>
import ChordCircle from './components/ChordCircle.vue'

export default {
  name: 'app',
  components: {
    ChordCircle
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
} */
</style>
